import React, { Component } from 'react'
import { connect } from 'react-redux'
import DtoPiezometer from '../../dto/DtoPiezometer'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import DtoPiezometryStationMeasure from '../../../station/dto/piezometer/DtoPiezometryStationMeasure'
import { getComponentWithId, getLabel, getObjectLabel, objectOf } from '../../../utils/StoreUtils'
import moment from 'moment'
import PiezometerStationAction from '../../../station/actions/PiezometerStationAction'
import DtoEvent from '../../../events/dto/DtoEvent'
import {
    findIndex,
    findLastIndex,
    groupBy,
    isEqual, isNaN, isNil, isNumber,
    keys,
    last,
    maxBy,
    meanBy,
    minBy,
    orderBy,
    pick,
    some,
    sum,
    template,
    uniqBy,
} from 'lodash'
import { getDateInRef, getDateWithHour, getDateWithHourString, getFullDate, getFullDateInRef } from '../../../utils/DateUtil'
import { getGmtSuffix, getMeasureTempRef, getOffsetFromTempRef } from '../../../utils/TempRefUtil'
import correctionImg from 'assets/pictures/pictos/correction.png'
import validateImg from 'assets/pictures/pictos/validate.png'
import compensationImg from 'assets/pictures/pictos/compensation.png'
import purgeImg from 'assets/pictures/pictos/purge.png'
import importImg from 'assets/pictures/pictos/import.png'
import thresholdImg from 'assets/pictures/pictos/threshold.png'
import eventImg from 'assets/pictures/pictos/event.png'
import optionsImg from 'assets/pictures/pictos/options.png'
import {
    automaticValues,
    chartLine,
    chartSymbol,
    exportExcelIcon,
    exportPictureIcon,
    getAxisIntervalFormatter,
    getChartDate,
    histogramIcon,
    legendSymbol,
    lineIcon,
    logIcon,
    setLogOptions,
    setYOptionsPiezo,
    thresholdIcon,
    yAutomaticScale,
} from '../../../components/echart/EChartUtils'
import { getColorCircleEvent, getColorFromPalette } from '../../../utils/ColorUtil'
import {
    getDisplayCote,
    getEventGraph,
    getEventsBar,
    getMeasureStatusColor,
    getMeasureStatusColorTable,
    getMeasureValue,
    getMeasureValueFromDepth,
    getNGFValue,
    getPiezometerOption,
    getPiezometerRawMeasures,
    getStaticDepthEvents,
    getThresholdsMarkLine,
} from '../../../utils/PiezometryUtils'
import Axis from '../../../components/echart/Axis'
import { DEFROUNDVALUE, groupSameSuccessiveValues, hasValue, round } from '../../../utils/NumberUtil'
import DtoPiezometerChartOptions from '../../../station/dto/piezometer/DtoPiezometerChartOptions'
import DtoPiezoThreshold from '../../../station/dto/piezometer/DtoPiezoThreshold'
import { exportFile, getDataWithHeaders } from '../../../utils/ExportDataUtil'
import EChart from '../../../components/echart/EChart'
import Card from '../../../components/card/Card'
import ValidationToolPanel from './tools/ValidationToolPanel'
import QualityAction from '../../../quality/actions/QualityAction'
import DtoStatus from '../../../quality/dto/DtoStatus'
import DtoQualification from '../../../quality/dto/DtoQualification'
import DtoSandreCode from '../../../referencial/dto/DtoSandreCode'
import ReferencialAction from '../../../referencial/action/ReferencialAction'
import ReactDOMServer from 'react-dom/server'
import { getSandreIndexLabel } from '../../../utils/StringUtil'
import { nbPerPageLabel, SANDRE } from '../../../referencial/constants/ReferencialConstants'
import ToastrAction from 'toastr/actions/ToastrAction'
import DeleteToolPanel from './tools/DeleteToolPanel'
import CompensationToolPanel from './tools/CompensationToolPanel'
import CorrectionToolPanel from './tools/CorrectionToolPanel'
import Line from '../../../components/echart/series/Line'
import DtoContributor from '../../../station/dto/DtoContributor'
import ContributorAction from '../../../referencial/components/contributor/actions/ContributorAction'
import EventsToolPanel from './tools/EventsToolPanel'
import EventsAction from '../../../events/actions/EventsAction'
import DtoJob from '../../../import/dto/DtoJob'
import JobAction from '../../../import/actions/JobAction'
import { MEASURE_COTE, PIEZO_L_STORAGE } from '../../constants/PiezometryConstants'
import { getLocalStorageJson, setLocalStorageJson } from '../../../utils/FormUtils'
import ChartTempRefChip from '../../../components/echart/ChartTempRefChip'
import ThresholdsToolPanel from './tools/ThresholdsToolPanel'
import ImportToolPanel from './tools/ImportToolPanel'
import { getStationArrowNav } from '../../../utils/ActionUtils'
import DtoPiezometerLight from '../../dto/DtoPiezometerLight'
import { push } from '@lagunovsky/redux-react-router'
import { getLinks, getStationTitleWithTownName } from '../../../utils/StationUtils'
import OptionsToolPanel from './tools/OptionsToolPanel'
import { getLisibleComment, getMaintenance1, getMaintenance2 } from './ValidationEventUtils'
import Other from '../../../components/actions/Other'
import Select from '../../../components/forms/Select'
import DtoParametrageDataType from '../../dto/DtoParametrageDataType'
import PiezometryAction from '../../actions/PiezometryAction'
import MessageCard from '../../../components/card/MessageCard'
import Icon from '../../../components/icon/Icon'
import { getQualifications, getStatuses, UNQUALIFIED } from '../../../utils/QualityUtils'
import queryString from 'query-string'
import { componentHasHabilitations } from '../../../utils/HabilitationUtil'
import { H_STATION_PIEZO_VALIDATION } from '../../../account/constants/AccessRulesConstants'
import { getQualificationSelectOptions, getStatusSelectOptions, statusIcon, statusLabel } from '../../../utils/StatusUtil'
import { setActions } from '../../../components/ActionUtil'
import DtoMeasureStats from '../../../station/dto/piezometer/DtoMeasureStats'
import { parseJsonObj } from 'utils/JsonUtils'
import { BAR, LINE } from 'components/echart/QualityChart'
import HomeAction from 'home/actions/HomeAction'
import { Grid, Icon as IconMui, Tooltip } from '@mui/material'
import MUIChartTabs from '../../../components/echart/MUIChartTabs'
import ChartOptionsChip from '../../../components/echart/ChartOptionsChip'
import { HISTO, J90 } from '../../../alerting/constants/ChartFollowContants'
import DtoPiezoMeasureLight from '../../dto/chart/DtoPiezoMeasureLight'
import { OTHER } from '../../../quality/constants/ChartConstant'
import { PIEZOMETRY_COLOR } from 'utils/constants/ColorTheme'
import { GREY } from 'components/constants/ColorConstant'
import { CardTable } from 'components/datatable/NewTable'
import { IS_INITIAL_POINT, IS_NOT_INITIAL_POINT, STATION_TYPE_NAME } from 'station/constants/StationConstants'
import { getGeneralLevelling } from '../../../utils/SettingUtils'

const exportHeaders = ['stationCode', 'stationName', 'date', 'value', 'initialValue', 'sensorValue', 'type', 'status', 'qualification', 'initialPoint']
const THRESHOLD = 0
const NOTHING = 2

class PiezometryValidationApp extends Component {
    constructor(props) {
        super(props)
        const { dataType, startDate, endDate, tool } = queryString.parse(props.location.search)
        const selectedDataType = dataType ? parseInt(dataType) : -1
        const selectedCodePoint = props.piezometer.link_pointPrels.filter(p => p.typeId === selectedDataType)[0]?.point
        const storedPreviousTime = getLocalStorageJson(PIEZO_L_STORAGE.TIME_VALIDATION)
        const selectedTime = isNaN(parseInt(storedPreviousTime)) ? (storedPreviousTime === HISTO ? J90 : storedPreviousTime) : parseInt(storedPreviousTime)
        const selectedOtherDates = selectedTime === OTHER ? (getLocalStorageJson(PIEZO_L_STORAGE.TIME_OTHER_VALIDATION) ?? {}) : {}
        const minDateFromPreviousTime = (() => {
            if (isNumber(selectedTime)) {
                if (selectedTime <= 2) {
                    return moment().subtract(selectedTime, 'days').valueOf()
                }
                return moment().subtract(selectedTime, 'days').startOf('day').valueOf()
            }
            return undefined
        })()
        this.state = {
            dataLoaded: false,
            locked: false,
            progress: 50,
            selectedDataType, // type profondeur par défaut
            selectedCodePoint, // code du point de prélèvement sélectionné
            piezoMode: selectedDataType === -1, // true si on affiche la piézo, false pour les donénes complémentaires
            minDate: selectedOtherDates.minDate ?? minDateFromPreviousTime,
            maxDate: selectedOtherDates.maxDate ?? moment().valueOf(),
            startDate: startDate ? parseInt(startDate) : null, // intervale de sélection de la validation (composants à droite)
            endDate: endDate ? parseInt(endDate) : null, // intervale de sélection de la validation (composants à droite)
            tool: tool || 'validation',
            measures: [],
            initialMeasures: [],
            supprMeasures: [],
            draggable: false,
            selectedPoint: null,
            changedValue: null, // offset pour la compensation, valeur pour la correction de dérive
            displayCote: getLocalStorageJson('DISPLAY_COTE') || MEASURE_COTE.DEPTH, // cote de calcul de la hauteur d'eau affichée
            tempRef: getLocalStorageJson(PIEZO_L_STORAGE.TEMP_REF) ?? undefined,
            lastLandmark: null, // hauteur du dernier repère
            groundRefAlti: null, // dernier repère défini pour le sol, sert à calculer les mesures par rapport au sol
            piezometerThresholds: [],
            piezometerImportedMeasure: [],
            display: 'cumul',
            startDateImport: 0,
            endDateImport: 0,
            time: selectedTime,
            chartOptions: [],
            replayingCorrection: false,
            compensationCoeff: null,
            tableView: false, // mode tableau
            displayModes: {
                auto: false,
                brute: true,
                min: false,
                max: false,
                average: false,
                suppr: false,
            },
            chartType: LINE,
            stack: undefined,
            isLogActive: false,
            displayLegend: true,
            stateThreshold: THRESHOLD,
            displayMarker: false,
            displayLine: true,
            filterStatusQualif: {
                qualifications: getQualificationSelectOptions().map(q => q.code),
                status: getStatusSelectOptions().map(s => s.code),
            },
        }
    }

    setTitle = (station, citiesIndex = this.props.citiesIndex) => {
        const townName = citiesIndex[station.townCode]?.name
        this.props.setTitle([{
            title: i18n.piezometry,
            href: 'piezometry',
        }, {
            title: getStationTitleWithTownName(station, townName),
            href: `station/piezometry/${station.id}`,
        }, {
            title: i18n.validation,
            href: `station/piezometry/${station.id}/validation`,
        }])
        this.updateActions()
    }

    updateActions = () => {
        setActions({
            other: this.getIntegrationOverviewLink(),
            links: getLinks(this.props.piezometer, this.props),
            arrowNav: getStationArrowNav('piezometry', this.props.piezometers, this.props.piezometer.id, s => this.props.push(`/station/piezometry/${s.id}/validation`)),
            exportmodel: () => ({
                stationId: this.props.piezometer.id.toString(),
                stationCode: this.props.piezometer.code,
                stationType: 'piezometry',
                environmentModels: this.props.typeEnvironmentModels,
            }),
        })
    }

    getIntegrationOverviewLink = () => ({ other: <Other className='clickable' onClick={() => this.props.push('/piezometry/integrationOverview')} tooltip={i18n.integrationOverview} icon='traffic' /> })

    componentDidUpdate = (prevProps) => {
        if (this.props.piezometers.length !== prevProps.piezometers.length) {
            this.updateActions()
        }

        if (!isEqual(this.props.piezometerThresholds, prevProps.piezometerThresholds)) {
            this.setState({ piezometerThresholds: this.props.piezometerThresholds })
        }
    }

    componentDidMount = () => {
        this.props.fetchContributors()
        this.props.fetchSandreCodes()
        if (this.props.piezometer.id) {
            this.calculateLastLandmarks(this.props.piezometer)
        }
        this.props.fetchPiezometerChartOptions(this.props.params.id, chartOptions => {
            this.setState({ chartOptions })
        })
        if (!this.props.jobs.length) {
            this.props.fetchFullJobs()
        }
        if (!this.props.piezometryDataTypes.length) {
            this.props.fetchPiezometryDataTypes().then(this.checkPiezoMode)
        } else {
            this.checkPiezoMode()
        }
        this.props.fetchPiezometerThresholds(parseInt(this.props.params.id), MEASURE_COTE.NGF)
        if (!componentHasHabilitations(H_STATION_PIEZO_VALIDATION)) { // A modifier quand react-router sera à jour
            this.props.push('/unauthorized')
            return
        }
        if (!isEqual(this.props.piezometerThresholds, this.state.piezometerThresholds)) {
            this.setState({ piezometerThresholds: this.props.piezometerThresholds })
        }
        if (this.props.piezometer.id) {
            this.setTitle(this.props.piezometer)
        }
        this.props.fetchPiezoMeasuresStats(parseInt(this.props.piezometer.id))
        this.loadData(pick(this.state, ['minDate', 'maxDate']))
    }

    calculateLastLandmarks = (piezo) => {
        const lastLandmark = maxBy(piezo.link_landmarks, 'startDate')
        const lastRefAlti = lastLandmark ? piezo.link_altimetrySystems.find(alt => alt.natureCode === lastLandmark.altimetrySystemNature && alt.startDate === lastLandmark.altimetrySystemDate) : null

        const groundRefALtis = piezo.link_altimetrySystems.filter(alt => alt.natureCode == 3)
        const groundRefAlti = groundRefALtis.length ? maxBy(groundRefALtis, 'startDate') : null
        this.setState({ lastLandmark: lastLandmark && lastRefAlti ? lastLandmark.height + lastRefAlti.altitude : null, groundRefAlti: groundRefAlti && groundRefAlti.altitude })
    }

    checkPiezoMode = () => {
        const currentDt = this.props.piezometryDataTypes.find(dt => dt.id == this.state.selectedDataType)
        if (currentDt && currentDt.isPiezo) {
            this.setState({ piezoMode: true })
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.piezometer.id && nextProps.piezometer.id || (keys(this.props.citiesIndex).length !== keys(nextProps.citiesIndex).length)) {
            this.setTitle(nextProps.piezometer, nextProps.citiesIndex)
            this.calculateLastLandmarks(nextProps.piezometer)
        }
    }

    getNewValidationWindow = (measures) => {
        const lastIndexValidated = findLastIndex(measures, m => m.status === 2 || m.status === 3)
        if (lastIndexValidated) {
            const firstNotValidated = measures[lastIndexValidated + 1]
            if (firstNotValidated) {
                const lastMeasure = last(measures)
                if (lastMeasure.measureIndex !== firstNotValidated.measureIndex) {
                    if (getLocalStorageJson('VALIDATE_FULL_DATE')) {
                        return {
                            startDate: moment(firstNotValidated.date).startOf('day').valueOf(),
                            endDate: lastMeasure.date,
                            endHour: lastMeasure.date,
                        }
                    }
                    return {
                        startDate: firstNotValidated.date,
                        endDate: lastMeasure.date,
                        endHour: lastMeasure.date,
                    }
                }
            }
        }
        return {}
    }

    loadData = (dates) => {
        const body = {
            startDate: dates.minDate ? moment(dates.minDate).subtract(6, 'hours').valueOf() : null,
            endDate: dates.maxDate,
            codepoint: this.state.selectedCodePoint,
            status: this.state.filterStatusQualif.status,
            qualifications: this.state.filterStatusQualif.qualifications,
            tempRefOffsetHours: this.getTempRefOffset(),
        }
        this.setState({ ...dates, dataLoaded: false, progress: 50 })
        this.props.fetchMeasures(this.props.piezometer.id, this.state.selectedDataType, body).then(() => {
            if (this.state.displayModes.suppr) {
                PiezometerStationAction.promisePiezoChartMeasures({ ...body, stationId: this.props.piezometer.id, dataType: this.state.selectedDataType, groupFunc: 'SUPPR' }).then(supprMeasures => {
                    const measures = orderBy(this.props.measures, 'date').map((m, i) => ({ ...m, measureIndex: i }))
                    this.setState({ measures, supprMeasures: supprMeasures.map(m => new DtoPiezoMeasureLight(m)), initialMeasures: measures, dataLoaded: true, ...this.getNewValidationWindow(measures) })
                })
            } else {
                const measures = orderBy(this.props.measures, 'date').map((m, i) => ({ ...m, measureIndex: i }))
                this.setState({ measures, initialMeasures: measures, dataLoaded: true, ...this.getNewValidationWindow(measures) })
            }
        })
    }

    getExportData = () => {
        const { measures, displayModes } = this.state
        const { piezometryDataTypes, piezometer } = this.props
        const chartMinDate = this.getMinDate()
        const chartMaxDate = this.state.maxDate || moment().valueOf()
        const rawMeasures = this.getSerieData(measures, chartMinDate, chartMaxDate, 'max', displayModes.brute)
        const chartName = getLabel(this.getDataTypes(), this.state.selectedDataType, 'label', 'id')
        const statuses = getStatuses()
        const qualifications = getQualifications()
        const roundValue = measures?.length ? piezometryDataTypes.find(pdt => pdt.id === measures[0].dataType)?.numberDecimal : DEFROUNDVALUE

        const data = rawMeasures.map(({ value: [date, measureValue, measure] }) => ({
            stationCode: piezometer.code,
            stationName: piezometer.name,
            date: getFullDateInRef(date, this.getTempRefOffset()),
            value: measureValue,
            type: chartName,
            status: getLabel(statuses, measure.status),
            qualification: getLabel(qualifications, measure.qualification || UNQUALIFIED),
            sensorValue: measure.initialValue,
            initialValue: this.state.piezoMode ? getMeasureValue(measure, this.state.displayCote, this.state.lastLandmark, this.state.groundRefAlti, true, roundValue) : measure.initialValue,
            initialPoint: measure.initialPoint === IS_INITIAL_POINT ? i18n.yes : i18n.no,
        }))

        if (data.length) {
            return getDataWithHeaders(data, exportHeaders)
        }
        return data
    }

    getGroupedMeasures = (measures, chartMinDate, chartMaxDate, groupFunc = 'max', forceBrute = false, forceDaily = false, initialMode = false) => {
        if (forceBrute) {
            return measures
        }
        const key = this.state.piezoMode ? (initialMode ? 'initialNGF' : 'NGF') : (initialMode ? 'initialValue' : 'value')
        const duration = moment.duration(moment(chartMaxDate).diff(chartMinDate))
        if (duration.months() > 3 || duration.years() >= 1 || forceDaily) {
            const offsetHours = this.getTempRefOffset()
            const measuresObj = groupBy(measures, m => getDateInRef(m.date, offsetHours))
            return Object.keys(measuresObj).map(date => {
                if (measuresObj[date].length === 1) {
                    return measuresObj[date][0]
                }
                if (groupFunc === 'max') {
                    const found = maxBy(measuresObj[date], key)
                    return { ...found, initialPoint: some(measuresObj[date], m => m.initialPoint === IS_INITIAL_POINT) ? IS_INITIAL_POINT : IS_NOT_INITIAL_POINT }
                }
                if (groupFunc === 'min') {
                    const found = minBy(measuresObj[date], key)
                    return { ...found, initialPoint: some(measuresObj[date], m => m.initialPoint === IS_INITIAL_POINT) ? IS_INITIAL_POINT : IS_NOT_INITIAL_POINT }
                }
                if (groupFunc === 'mean') {
                    return {
                        ...measuresObj[date][0],
                        initialPoint: some(measuresObj[date], m => m.initialPoint === IS_INITIAL_POINT) ? IS_INITIAL_POINT : IS_NOT_INITIAL_POINT,
                        NGF: meanBy(measuresObj[date], key),
                        value: meanBy(measuresObj[date], 'value'),
                        date: moment(measuresObj[date][0].date).hour(12).valueOf(),
                    }
                }
                return measuresObj[date][0]
            })
        }
        return measures
    }

    getSerieData = (measures, chartMinDate, chartMaxDate, groupFunc = 'max', forceBrute = false, forceDaily = false, initialMode = false, unit = undefined) => {
        const { startDate: start, endDate: end, displayMarker } = this.state
        const { piezometryDataTypes } = this.props
        const roundValue = measures?.length ? piezometryDataTypes.find(pdt => pdt.id === measures[0].dataType)?.numberDecimal : DEFROUNDVALUE
        const displayMarkerOptions = displayMarker ? { symbolSize: 6, symbol: 'circle' } : {}
        const results = this.getGroupedMeasures(measures, chartMinDate, chartMaxDate, groupFunc, forceBrute, forceDaily, initialMode).flatMap(obj => {
            const date = obj.date
            const symbolSize =
                obj.initialPoint === IS_INITIAL_POINT ? { symbolSize: 5 } :
                    ((this.state.tool === 'validation' && this.state.draggable && (!this.state.selectedPoint || this.state.selectedPoint.measureIndex === obj.measureIndex)) ? { symbolSize: 5 } :
                        (this.state.tool === 'correction' && start && end ? { symbolSize: date === end ? 10 : 0 } :
                            this.state.draggable && start && end ? { symbolSize: date >= start && date <= end ? 5 : 0 } : {}
                        )
                    )
            const calculated = this.state.piezoMode ? getMeasureValue(obj, this.state.displayCote, this.state.lastLandmark, this.state.groundRefAlti, initialMode, roundValue) : obj.value
            if (obj.initialPoint === IS_INITIAL_POINT) {
                return [
                    { value: [moment(date).subtract(1, 'second').valueOf(), null, { ...obj, calculated }, unit] },
                    { value: [date, calculated, { ...obj, calculated }], symbolSize: 5, ...symbolSize, unit, ...displayMarkerOptions },
                ]
            }
            return [{ value: [date, calculated, { ...obj, calculated }], ...symbolSize, unit, symbol: 'none', ...displayMarkerOptions }]
        })
        return orderBy(results, m => m.value[0])
    }


    addEvents = (series, grids, xAxis, yAxis, gridsHeights, chartMinDate, chartMaxDate, axisLabelObj, events) => {
        const { displayCote, lastLandmark, groundRefAlti } = this.state
        const eventOptions = {
            tooltip: {
                trigger: 'item',
                formatter: (params) => {
                    const eventsList = events.filter(e => {
                        return e.graph === '1' && (e.startDate && e.endDate ? (
                            e.startDate <= params.value[0] && e.endDate >= params.value[0]
                        ) : getDateWithHour(e.date, e.eventHour).isSame(params.value[0], 'day'))
                    })
                    const date = eventsList.length ? getFullDate(getDateWithHour(eventsList[0].date, eventsList[0].eventHour)) : ''
                    return `${date}<br />${eventsList.reduce((acc, v) => {
                        const comment = v.comment ? getLisibleComment(v.comment) : i18n.event
                        const ns = (v.ns ? `<br />${i18n.staticLevel} : ${getMeasureValueFromDepth({ value: v.ns }, displayCote, lastLandmark, groundRefAlti)}` : '')
                        const nc = (v.nc ? `<br />${i18n.centralLevel} : ${getMeasureValueFromDepth({ value: v.nc }, displayCote, lastLandmark, groundRefAlti)}` : '')
                        const recalibration = ((v.ns && v.nc) ? `<br /> ${i18n.calibrationUpdate} : ${v.calibrationUpdate ? i18n.yes.toUpperCase() : i18n.no.toUpperCase()} ${v.calibrationUpdate ? `(${round(getMeasureValueFromDepth({ value: v.ns }, displayCote, lastLandmark, groundRefAlti) - getMeasureValueFromDepth({ value: v.nc }, displayCote, lastLandmark, groundRefAlti), 3)})` : ''} ` : '')
                        return `${acc}<br />${getColorCircleEvent(v.eventType)}${comment}${ns}${nc}${recalibration}`
                    }, i18n.events)}`
                },
            },
            itemStyle: {
                normal: {
                    opacity: 0.5,
                },
            },
            yAxisIndex: 1,
        }
        series.push(getEventGraph(events, eventOptions))
        series.push(getEventsBar(events, { tooltip: eventOptions.tooltip }))
        grids.push({
            top: sum(gridsHeights),
            right: '2%',
            height: 40,
            left: 100,
        })
        xAxis.push(Axis({
            type: 'time',
            position: 'bottom',
            min: chartMinDate,
            max: chartMaxDate,
            interval: axisLabelObj.interval,
            axisLabel: { show: false },
            axisLine: { show: false },
            axisTick: { show: false },
        }))
        yAxis.push(Axis({
            type: 'value',
            data: [i18n.events],
            nameLocation: 'middle',
            minInterval: 1,
            nameGap: 40,
            position: 'right',
            axisLabel: { show: false },
            axisLine: { show: false },
            axisTick: { show: false },
        }))
        yAxis.push(Axis({
            type: 'category',
            data: [i18n.events],
            nameLocation: 'middle',
            minInterval: 1,
            nameGap: 40,
            position: 'left',
        }))
        gridsHeights.push(60)
    }

    getMarkAreas = () => {
        const groups = groupSameSuccessiveValues(this.state.measures, 'status')
        const areas = groups.filter(g => g.length && g[0].status && g[0].status != 1).map(group => {
            const start = last(group)
            const end = group[0]
            return [
                { xAxis: start.date, itemStyle: { color: getMeasureStatusColor(end.status), opacity: 0.5 } },
                { xAxis: end.date, itemStyle: { color: getMeasureStatusColor(end.status), opacity: 0.5 } },
            ]
        })
        return areas.length ? { markArea: { data: areas } } : {}
    }

    getSelectedInterval = (otherlines) => {
        const offsetHours = this.getTempRefOffset()
        if (!(this.state.draggable && this.state.tool === 'validation')) {
            const data = [
                this.state.startDate,
                this.state.endDate,
            ].filter(d => !!d)
            if (data.length) {
                return {
                    markLine: {
                        symbol: 'none',
                        silent: false,
                        label: {
                            show: true,
                            position: 'middle',
                            formatter(v) {
                                return getDateInRef(v.value, offsetHours)
                            },
                        },
                        data: [...data.map(d => ({ xAxis: d })), ...otherlines.data],
                        lineStyle: {
                            color: GREY,
                        },
                    },
                }
            }
            return {
                markLine: {
                    symbol: 'none',
                    label: {
                        show: true,
                        position: 'middle',
                        formatter(v) {
                            return getDateInRef(v.date, offsetHours)
                        },
                    },
                    data: [...otherlines.data],
                    lineStyle: {
                        color: GREY,
                    },
                },
            }
        }
        return {}
    }

    getManualImportMeasures = (chartMinDate, chartMaxDate) => {
        const { startDateImport, endDateImport, piezometerImportedMeasure, display, measures } = this.state
        if (piezometerImportedMeasure.length) {
            const filteredImportedMeasure = piezometerImportedMeasure.filter(measure => measure.date >= startDateImport && measure.date <= endDateImport)
            const importedMeasures = (() => {
                switch (display) {
                    case 'addEnd':
                        const lastDate = measures.length ? last(measures).date : null
                        return lastDate ? filteredImportedMeasure.filter(measure => measure.date >= lastDate) : filteredImportedMeasure
                    case 'replace':
                        return filteredImportedMeasure
                    default:
                        return uniqBy([
                            ...this.state.measures,
                            ...filteredImportedMeasure,
                        ], m => getFullDate(m.date)).filter(measure => measure.date >= startDateImport && measure.date <= endDateImport)
                }
            })()
            return this.getSerieData(importedMeasures, chartMinDate, chartMaxDate)
        }
        return []
    }

    addMeasures = (series, grids, xAxis, yAxis, gridsHeights, chartMinDate, chartMaxDate, axisLabelObj, chronicMeasures, initialMeasures) => {
        const { selectedDataType, minDate, piezoMode, displayCote, lastLandmark, groundRefAlti, piezometerThresholds,
            stateThreshold, displayLine, isLogActive, stack, chartType, replayingCorrection, measures,
            startDate, endDate } = this.state
        const { piezometerStatistics, stationEvents } = this.props
        const unit = piezometerStatistics.find(t => t.typeId == selectedDataType)?.unit ?? ''
        const label = piezometerStatistics.find(t => t.typeId == selectedDataType)?.label ?? ''

        grids.push({
            top: sum(gridsHeights),
            right: '2%',
            height: 550,
            left: 100,
        })

        // mesures initiales (colonne valeurmesure = valeur non modifées)
        if (chronicMeasures.initial.length) {
            series.push(getPiezometerRawMeasures(chronicMeasures.initial, grids.length - 1, [], [], {
                color: GREY,
                name: i18n.initialMeasure,
            }, true))
        }

        // static level serie (from events)
        const eventsStaticDepth = stationEvents.filter(e => {
            const d = getDateWithHour(e.date, e.eventHour).valueOf()
            return hasValue(e.ns) && e.eventType !== 'T' && d >= minDate
        }).map(e => ({ ns: e.ns, nc: e.nc, calibrationUpdate: e.calibrationUpdate, value: [getDateWithHour(e.date, e.eventHour).valueOf(), getMeasureValueFromDepth({ value: e.ns }, displayCote, lastLandmark, groundRefAlti)] }))
        if (eventsStaticDepth.length && piezoMode) {
            series.push(getStaticDepthEvents(eventsStaticDepth, grids.length - 1, { name: i18n.staticLevel }, true))
        }

        // manual import measures
        const manualImportMeasures = this.getManualImportMeasures(chartMinDate, chartMaxDate)
        if (manualImportMeasures) {
            series.push(getPiezometerRawMeasures(manualImportMeasures, grids.length - 1, [], [], { color: 'red', name: i18n.newValue }, true))
        }

        // deleted measures
        const deletedMeasures = chronicMeasures.suppr ?? []
        const deletedAndManualMeasures = [...manualImportMeasures, ...deletedMeasures]

        // thresholds
        const thresholds = stateThreshold === THRESHOLD ? piezometerThresholds
            .filter(t => {
                if (t.isDeleted || !hasValue(t.name)) {
                    return false
                }
                return selectedDataType === parseInt(t.dataType)
            }).map(t => ({ ...t, lastLandmark, groundRefAlti, displayCote, unit })) : []
        const thresholdValues = thresholds.map(t => ({ ...t, value: [null, piezoMode ? (getMeasureValue({ NGF: t.value, landmark: t.lastLandmark, refAlti: 0 }, t.displayCote, t.lastLandmark, t.groundRefAlti) || 0) : t.value] }))
        const showSymbol = { showSymbol: true, showAllSymbol: true }

        const allDatas = automaticValues(eventsStaticDepth, thresholdValues, chronicMeasures.raw, chronicMeasures.max, chronicMeasures.min, chronicMeasures.average, chronicMeasures.initial, initialMeasures, deletedAndManualMeasures)
        const yScale = yAutomaticScale(eventsStaticDepth, thresholdValues, chronicMeasures.raw, chronicMeasures.max, chronicMeasures.min, chronicMeasures.average, chronicMeasures.initial, initialMeasures, deletedAndManualMeasures)
        this.yScale = yScale // please do not remove

        const defaultOptions = {
            lineStyle: {
                opacity: displayLine ? 1 : 0,
            },
            max: (() => {
                if (isLogActive) {
                    return undefined
                }
                return yScale.max
            })(),
            min: (() => {
                if (isLogActive) {
                    return undefined
                }
                if (chartType === BAR || stack) {
                    return 0
                }
                return yScale.min
            })(),
        }

        // initial measures (before saving changes)
        series.push(getPiezometerRawMeasures(initialMeasures, grids.length - 1, [], [], {
            color: GREY,
            name: i18n.initialMeasure,
            ...defaultOptions,
        }, true, chartType !== LINE))

        // imported measures (values that can't be changed after the import)
        if (replayingCorrection) {
            series.push(getPiezometerRawMeasures(this.getSerieData(
                measures.filter(m => m.date >= startDate && m.date <= endDate).map(m => ({ ...m, NGF: m.initialNGF, value: m.initialValue })),
                chartMinDate, chartMaxDate,
            ), grids.length - 1, [], [], {
                color: GREY,
                name: i18n.importedMeasure,
                ...defaultOptions,
            }, true, this.state.chartType !== LINE))
        }

        // raw measures
        series.push(getPiezometerRawMeasures(chronicMeasures.raw, grids.length - 1, [], [], {
            ...defaultOptions,
            ...this.getMarkAreas(),
            ...this.getSelectedInterval(
                getThresholdsMarkLine(thresholds, piezoMode),
            ),
            ...showSymbol,
            name: piezoMode ? (label || i18n.chronic) : getLabel(this.getDataTypes(), selectedDataType, 'label', 'id'),
        }, true, chartType !== LINE))

        // other display modes
        if (chronicMeasures.max.length) {
            series.push(getPiezometerRawMeasures(chronicMeasures.max, grids.length - 1, [], [], {
                color: '#2196F3',
                name: i18n.max,
                ...defaultOptions,
            }, true, chartType !== LINE))
        }
        if (chronicMeasures.min.length) {
            series.push(getPiezometerRawMeasures(chronicMeasures.min, grids.length - 1, [], [], {
                color: '#F44336',
                name: i18n.min,
                ...defaultOptions,
            }, true, chartType !== LINE))
        }
        if (chronicMeasures.average.length) {
            series.push(getPiezometerRawMeasures(chronicMeasures.average, grids.length - 1, [], [], {
                color: '#4CAF50',
                name: i18n.average,
                ...defaultOptions,
            }, true, chartType !== LINE))
        }
        if (chronicMeasures.suppr.length) {
            series.push(getPiezometerRawMeasures(chronicMeasures.suppr, grids.length - 1, [], [], {
                color: '#6d3200',
                name: i18n.supprMeasures,
                ...defaultOptions,
            }, true, chartType !== LINE))
        }

        const option = getPiezometerOption(selectedDataType, this.state.chartOptions)

        xAxis.push(Axis({
            type: 'time',
            position: 'bottom',
            min: chartMinDate,
            max: chartMaxDate,
            interval: axisLabelObj.interval,
            gridIndex: grids.length - 1,
            showSplitLine: option && hasValue(option.displayXIntervalYear) ? option.displayXIntervalYear === '1' : true,
            axisLabel: { show: true, formatter: axisLabelObj.formatter },
        }))

        yAxis.push(Axis(Object.assign({}, {
            type: isLogActive ? 'log' : 'value',
            nameLocation: 'middle',
            name: piezoMode ? `${label} ${unit ? `[${unit}]` : ''}` : `${getLabel(this.getDataTypes(), selectedDataType, 'label', 'id')} ${unit ? `[${unit}]` : ''}`,
            gridIndex: grids.length - 1,
            nameGap: 40,
            inverse: piezoMode ? displayCote !== MEASURE_COTE.NGF : false,
            showSplitLine: option && hasValue(option.displayYIntervalYear) ? option.displayYIntervalYear === '1' : true,
        },
        yScale,
        setYOptionsPiezo(option, selectedDataType, yScale, displayCote, lastLandmark, groundRefAlti),
        setLogOptions(isLogActive, allDatas),
        )))
        gridsHeights.push(600)
    }

    addProducers = (series, grids, xAxis, yAxis, gridsHeights, chartMinDate, chartMaxDate, axisLabelObj, rawMeasures) => {
        const groups = groupSameSuccessiveValues(rawMeasures, 'producer')
        const byProducer = groupBy(groups.filter(g => g.length && hasValue(g[0].producer)), group => group[0].producer)
        Object.keys(byProducer).forEach((producer, idx) => {
            const producerGroups = byProducer[producer]
            const producerName = getLabel(this.props.contributors, producer, 'mnemonique')
            grids.push({
                top: sum(gridsHeights),
                right: '2%',
                height: 30,
                left: 100,
            })

            const areas = producerGroups.map(group => {
                const start = last(group)
                const end = group[0]
                return [
                    { xAxis: start.date, itemStyle: { color: getColorFromPalette(idx), opacity: 0.5 } },
                    { xAxis: end.date, itemStyle: { color: getColorFromPalette(idx), opacity: 0.5 } },
                ]
            })
            series.push(Line({
                data: [],
                name: producerName,
                yAxisIndex: grids.length,
                xAxisIndex: grids.length - 1,
                connectNulls: false,
                showSymbol: false,
                color: getColorFromPalette(idx),
                serieId: producerName,
                markArea: { data: areas },
            }))
            xAxis.push(Axis({
                type: 'time',
                position: 'bottom',
                min: chartMinDate,
                max: chartMaxDate,
                interval: axisLabelObj.interval,
                gridIndex: grids.length - 1,
                axisLabel: { show: false },
                axisLine: { show: false },
                axisTick: { show: false },
                showSplitLine: true,
            }))
            yAxis.push(Axis({
                type: 'value',
                nameLocation: 'center',
                name: producerName,
                gridIndex: grids.length - 1,
                nameGap: 5,
                nameRotate: 0,
                showSplitLine: true,
            }))
            gridsHeights.push(30)
        })
    }

    getStationTempRefOffset = () => getMeasureTempRef(this.props.piezometer?.link_tempRefs, this.state.selectedDataType, this.props.sandreCodes)

    getTempRefOffset = () => {
        const { tempRef } = this.state
        return isNil(tempRef) ? this.getStationTempRefOffset() : getOffsetFromTempRef(tempRef, this.props.sandreCodes)
    }

    changeTempRef = (tempRef) => {
        setLocalStorageJson(PIEZO_L_STORAGE.TEMP_REF, tempRef ?? null)
        this.setState({ tempRef, dataLoaded: false }, () => this.loadData(pick(this.state, ['minDate', 'maxDate'])))
    }

    getMinDate = () => {
        if (this.state.minDate) {
            return this.state.minDate
        }
        const minAllData = minBy(this.props.measures, 'date')
        return minAllData ? minAllData.date : moment().subtract(1, 'days').valueOf()
    }

    getTooltip() {
        const {
            displayCote,
            lastLandmark,
            groundRefAlti,
            piezoMode,
        } = this.state
        const {
            sandreIndex,
            contributors,
        } = this.props
        const offsetHours = this.getTempRefOffset()
        return {
            trigger: 'axis',
            formatter: params => {
                const date = params[0].value[2] ? `${getFullDateInRef(params[0].value[2].date, offsetHours)}${getGmtSuffix(offsetHours)}` : ''
                const dateStaticLevel = params[0].value[0] ? `${getFullDateInRef(params[0].value[0], offsetHours)}${getGmtSuffix(offsetHours)}` : ''
                const paramsOrderStaticLevel = uniqBy(params.filter(o => o.seriesName === i18n.staticLevel).map(p => {
                    const valueNs = p.data?.ns ? getMeasureValueFromDepth({ value: p.data.ns }, displayCote, lastLandmark, groundRefAlti) : ''
                    const valueNc = p.data?.nc ? getMeasureValueFromDepth({ value: p.data.nc }, displayCote, lastLandmark, groundRefAlti) : ''
                    const calibrationUpdateValue = (p.data?.ns && p.data?.nc) ? round(valueNs - valueNc, 3) : ''
                    return {
                        value: p.value[0],
                        ns: valueNs,
                        nc: valueNc,
                        calibrationUpdate: `${i18n.calibrationUpdate} : ${p.data?.calibrationUpdate ? i18n.yes.toUpperCase() : i18n.no.toUpperCase()} ${p.data?.calibrationUpdate ? ` ${p.data?.calibrationUpdate ? `(${calibrationUpdateValue})` : ''}` : ''}`,
                    }
                }))
                const resultStaticLevel = paramsOrderStaticLevel.map(o => ` <br /> ${i18n.staticLevel}: ${o.ns} <br /> ${i18n.centralLevel}: ${o.nc} <br /> ${o.calibrationUpdate} <br /> `)
                const otherSeriesNames = [i18n.initialMeasure, i18n.importedMeasure, i18n.min, i18n.max, i18n.average]
                const paramsOrder = uniqBy(params.filter(o => hasValue(o.value[2]) && o.seriesName !== i18n.events).map(o => ({
                    marker: o.marker,
                    seriesName: o.seriesName,
                    value: o.value[2].calculated,
                    unit: o.data.unit,
                    status: hasValue(o.value[2].validity) ? ReactDOMServer.renderToString(<Grid container><Grid size={12} className='valign-wrapper'>{statusIcon(o.value[2], 20)}&nbsp;{statusLabel(o.value[2])}</Grid></Grid>) : '',
                    otherData: !otherSeriesNames.includes(o.seriesName) && o.value[2] ? [
                        hasValue(o.value[2].nature) && (`Nature : ${getSandreIndexLabel(sandreIndex, SANDRE.PIEZOMETER_MEASURE_NATURE, o.value[2].nature)}`),
                        hasValue(o.value[2].producer) && (`${i18n.producer} : ${getLabel(contributors, o.value[2].producer, 'mnemonique')}`),
                    ].filter(s => !!s).join('<br/>') : '',
                })).reverse(), 'value')
                const result = paramsOrder.map(o => `${o.marker} ${o.seriesName} : ${o.value} ${o.unit ?? ''} <br/> ${o.status}${o.otherData}`).join('<br/>')
                const cote = `${i18n.display} : ${piezoMode ? getDisplayCote(displayCote) : i18n.sensorOfValue}`
                return `${date || dateStaticLevel} <br /> ${cote} <br /> ${result}  <br /> ${resultStaticLevel}`
            },
        }
    }

    onCancel = () => this.setState({
        piezometerThresholds: this.props.piezometerThresholds,
        piezometerImportedMeasure: [],
        measures: orderBy(this.props.measures, 'date').map((m, i) => ({ ...m, measureIndex: i })),
        selectedPoint: null,
        replayingCorrection: false,
        changedValue: null,
        compensationCoeff: null,
    })

    getLegend = () => ({
        top: 20,
        left: '5%',
        right: `${30 * 8 + 50}px`,
        type: 'scroll',
        show: this.state.displayLegend,
    })

    getToolbox = () => {
        const {
            chartType,
            stack,
            isLogActive,
            displayLegend,
            stateThreshold,
            displayMarker,
            displayLine,
        } = this.state

        const {
            piezometer,
            piezometerThresholds,
        } = this.props

        const stationTitle = `[${piezometer.code}] ${piezometer.name}`

        return {
            top: '25px',
            right: '35px',
            showTitle: false,
            itemSize: 18,
            tooltip: {
                show: true,
                position: 'bottom',
            },
            feature: {
                myToolLine: {
                    show: true,
                    title: i18n.lines,
                    icon: lineIcon,
                    onclick: () => this.setState({ stack: undefined, chartType: LINE }),
                    iconStyle: {
                        borderColor: chartType === LINE ? '#4d93c9' : '#5c5c5c',
                    },
                },
                myToolBar: {
                    show: true,
                    title: i18n.histogram,
                    icon: histogramIcon,
                    onclick: () => this.setState({ stack: undefined, chartType: BAR, isLogActive: false }),
                    iconStyle: {
                        borderColor: chartType === BAR && !stack ? '#4d93c9' : '#5c5c5c',
                    },
                },
                myToolLog: {
                    show: true,
                    title: i18n.logarithm,
                    icon: logIcon,
                    onclick: () => this.setState(prev => ({ stack: undefined, chartType: LINE, isLogActive: !prev.isLogActive })),
                    iconStyle: {
                        borderColor: isLogActive ? '#4d93c9' : '#5c5c5c',
                    },
                },
                myToolThreshold: {
                    show: !!piezometerThresholds.length,
                    title: i18n.toggleThreshold,
                    icon: thresholdIcon,
                    onclick: () => this.setState(prev => ({ stateThreshold: prev.stateThreshold === THRESHOLD ? NOTHING : THRESHOLD })),
                    iconStyle: {
                        borderColor: stateThreshold !== NOTHING ? '#4d93c9' : '#5c5c5c',
                    },
                },
                myToolToggleLegend: {
                    show: true,
                    title: i18n.toggleLegend,
                    icon: legendSymbol,
                    onclick: () => this.setState(prev => ({ displayLegend: !prev.displayLegend })),
                    iconStyle: {
                        borderColor: displayLegend ? '#4d93c9' : '#5c5c5c',
                    },
                },
                myToolToggleMarker: {
                    show: true,
                    title: i18n.toggleMarker,
                    icon: chartSymbol,
                    onclick: () => this.setState(prev => ({ displayMarker: !prev.displayMarker })),
                    iconStyle: {
                        borderColor: displayMarker ? '#4d93c9' : '#5c5c5c',
                    },
                },
                myToolToggleLine: {
                    show: true,
                    title: i18n.toggleLine,
                    icon: chartLine,
                    onclick: () => this.setState(prev => ({ displayLine: !prev.displayLine })),
                    iconStyle: {
                        borderColor: displayLine ? '#4d93c9' : '#5c5c5c',
                    },
                },
                saveAsImage: {
                    show: true,
                    title: i18n.pictureExport,
                    icon: exportPictureIcon,
                    name: `${i18n.graph} ${stationTitle}`,
                },
                myToolExport: {
                    show: true,
                    title: i18n.excelExport,
                    icon: exportExcelIcon,
                    onclick: () => {
                        exportFile({
                            data: this.getExportData(),
                            exportType: 'xlsx',
                            titleFile: `${i18n.overview} ${stationTitle}`,
                        })
                    },
                },
                restore: {
                    show: true,
                    title: i18n.restore,
                },
            },
        }
    }

    getChart = () => {
        const { maxDate, time } = this.state
        const { minDate: formattedMinDate, maxDate: formattedMaxDate } = getChartDate(this.getMinDate(), maxDate, time, this.getTempRefOffset())
        const chartMinDate = formattedMinDate || this.getMinDate()
        const chartMaxDate = formattedMaxDate || maxDate || moment().valueOf()
        const unit = this.props.piezometerStatistics.find(t => t.typeId === this.state.selectedDataType)?.unit ?? ''

        const modes = this.state.displayModes
        const chronicMeasures = {
            raw: modes.brute || modes.auto ? this.getSerieData(this.state.measures, chartMinDate, chartMaxDate, 'max', modes.brute, false, false, unit) : [],
            min: modes.min ? this.getSerieData(this.state.measures, chartMinDate, chartMaxDate, 'min', false, true) : [],
            max: modes.max ? this.getSerieData(this.state.measures, chartMinDate, chartMaxDate, 'max', false, true) : [],
            average: modes.average ? this.getSerieData(this.state.measures, chartMinDate, chartMaxDate, 'mean', false, true) : [],
            initial: modes.initialBrute ? this.getSerieData(this.state.measures, chartMinDate, chartMaxDate, 'max', modes.brute, false, true) : [],
            suppr: modes.suppr ? this.getSerieData(this.state.supprMeasures, chartMinDate, chartMaxDate, 'max', false, true) : [],
        }
        const rawMeasures = chronicMeasures.raw
        const initialMeasures = modes.brute || modes.auto ? this.getSerieData(this.state.initialMeasures, chartMinDate, chartMaxDate, 'max', modes.brute, false, false, unit) : []

        // get events
        const events = this.props.stationEvents.filter(e => hasValue(e.date)).filter(e => {
            const eventDate = getDateWithHour(e.date, e.eventHour).valueOf()
            const problem = e.problem?.startsWith('{') ? parseJsonObj(e.problem) : undefined
            return eventDate >= chartMinDate && eventDate <= chartMaxDate && e.graph === '1' && (e.eventType !== 'T' || (
                (this.state.tool === 'correction' && problem?.tool === 'correction' && e.startDate >= chartMinDate) ||
                (this.state.tool === 'compensation' && problem?.tool === 'compensation' && e.startDate >= chartMinDate) ||
                (problem?.landmarkChange)
            ))
        })

        // construct echart options
        const axisLabelObj = getAxisIntervalFormatter(this.state.maxDate ? moment(this.state.maxDate) : moment(), moment(this.state.minDate || chartMinDate), undefined, this.getTempRefOffset())
        const series = []
        const grids = []
        const xAxis = []
        const yAxis = []
        const gridsHeights = [60]

        this.addEvents(series, grids, xAxis, yAxis, gridsHeights, chartMinDate, chartMaxDate, axisLabelObj, events)
        this.addMeasures(series, grids, xAxis, yAxis, gridsHeights, chartMinDate, chartMaxDate, axisLabelObj, chronicMeasures, initialMeasures)
        this.addProducers(series, grids, xAxis, yAxis, gridsHeights, chartMinDate, chartMaxDate, axisLabelObj, this.state.measures)

        const options = {
            series,
            tooltip: this.getTooltip(),
            grid: grids,
            xAxis,
            yAxis,
            axisPointer: {
                link: { xAxisIndex: 'all' },
            },
            setDataZoom: !this.state.draggable,
            height: sum(gridsHeights),
            toolbox: this.getToolbox(),
            legend: this.getLegend(),
            graphic: !this.state.draggable ? {
                type: 'rect',
                position: [0, 0],
                shape: {
                    x: 100,
                    y: 120,
                    width: 10000,
                    height: 550,
                },
                invisible: true,
                z: 500,
                onclick: this.selectOnChart,
            } : undefined,
            // legend: this.getLegend()
        }
        setTimeout(() => this.setDraggable(rawMeasures), 100) // Dont remove ! (gestion des mesures draggables sur le graphique)
        return (
            <EChart options={options} id='piezometryDashboardChart' onClick={this.onEventOnChartSelected} />
        )
    }

    onEventOnChartSelected = (params) => {
        if (this.state.selectionMode === 'correctionEvent' && params.value[2] && params.value[2].eventType === 'T') {
            const event = params.value[2]
            if (event.problem && event.problem.startsWith('{')) {
                getComponentWithId('#correctionToolPanel').onReplayOldCorrection(event)
            }
        }
        if (this.state.selectionMode === 'compensationEvent' && params.value[2] && params.value[2].eventType === 'T') {
            const event = params.value[2]
            if (event.problem && event.problem.startsWith('{')) {
                getComponentWithId('#compensationToolPanel').onReplayOldCompensation(event)
            }
        }
    }

    selectOnChart = (item) => {
        if (this.state.selectionMode && this.state.measures.length) {
            const [selectedDate] = getComponentWithId('.sieauChart').getInstance().convertFromPixel({ xAxisIndex: 1, yAxisIndex: 2 }, [item.offsetX, item.offsetY])
            const nextOneIdx = findIndex(this.state.measures, m => m.date > selectedDate)
            const next = nextOneIdx !== -1 ? this.state.measures[nextOneIdx] : null
            const previous = nextOneIdx !== -1 ? this.state.measures[nextOneIdx - 1] : last(this.state.measures)
            const foundMeasure = minBy([previous, next].filter(m => !!m), m => m.date > selectedDate ? m.date - selectedDate : selectedDate - m.date)
            this.selectPoint(foundMeasure)
        }
    }

    selectPoint = (point) => {
        if (this.state.selectionMode && this.state.measures.length) {
            const found = point.date
            if (this.state.selectionMode === 'start') {
                this.setState({ selectionMode: 'end', startDate: found })
            } else if (this.state.selectionMode === 'end') {
                if (found < this.state.startDate) {
                    this.props.error(template(i18n.dateBoundMinError)({ date: getFullDateInRef(this.state.startDate, this.getTempRefOffset()) }))
                } else {
                    this.setState({ selectionMode: null, endDate: found })
                }
            } else if (this.state.selectionMode === 'point') {
                this.setState({ selectionMode: 'point', startDate: found, endDate: found, selectedPoint: point })
            }
        }
    }

    updateTechnicalEvent = (measures, event) => {
        const { tool, startDate, endDate, changedValue, compensationCoeff } = this.state
        const offsetHours = this.getTempRefOffset()
        const getDates = () => measures.length > 1 ? `${i18n.fromDate} ${getFullDateInRef(startDate, offsetHours)} ${i18n.to} ${getFullDateInRef(endDate, offsetHours)}` : `${i18n.fromDate} ${getFullDateInRef(startDate, offsetHours)}`
        const eventProps = (() => {
            switch (tool) {
                case 'compensation':
                    const m1 = getMaintenance1(this.props.stationEvents, startDate, this.state)
                    const m2 = getMaintenance2(this.props.stationEvents, endDate, this.state)
                    const NGFoffset = this.state.displayCote === MEASURE_COTE.NGF ? changedValue : -changedValue
                    const NGFcoeff = compensationCoeff || 1
                    return {
                        comment: `${i18n.compensation} ${getDates()}\n
                    ${`Coeff : ${NGFcoeff}m NGF`}\n${`Offset : ${NGFoffset}m NGF`}${m1 ? `\n\n${m1}` : ''}${m2 ? `\n\n${m2}` : ''}`,
                        problem: JSON.stringify({
                            tool,
                            coeff: NGFcoeff,
                            offset: NGFoffset,
                        }),
                    }
                case 'correction':
                    const mcorr1 = getMaintenance1(this.props.stationEvents, startDate, this.state)
                    const mcorr2 = getMaintenance2(this.props.stationEvents, endDate, this.state)
                    const NGFValue = this.state.displayCote === MEASURE_COTE.NGF ? changedValue : getNGFValue({ value: changedValue }, this.state.displayCote, this.state.lastLandmark, this.state.groundRefAlti)
                    const depthValue = this.state.displayCote === MEASURE_COTE.NGF ? getMeasureValue({ NGF: changedValue }, MEASURE_COTE.DEPTH, this.state.lastLandmark, this.state.groundRefAlti) : changedValue
                    return {
                        comment: `${i18n.driftingCorrection} ${getDates()}\n
                            ${i18n.valueLabel} : ${depthValue} m (${NGFValue} m NGF)${mcorr1 ? `\n\n${mcorr1}` : ''}${mcorr2 ? `\n\n${mcorr2}` : ''}`,
                        problem: JSON.stringify({ tool, NGFValue, depthValue }),
                    }
                default:
                    return { comment: '' }
            }
        })()

        const newEvent = {
            ...event,
            eventType: 'T',
            date: moment().valueOf(),
            eventHour: moment().valueOf(),
            graph: '1',
            ...eventProps,
        }

        this.props.updateEvent('piezometry', this.props.params.id, event.number, newEvent)
            .then(() => this.setState({ open: false }))
    }

    createTechnicalEvent = (measures, toolState) => {
        if (!this.state.piezoMode) {
            return
        }
        const { tool, startDate, endDate, changedValue, compensationCoeff, piezometerThresholds } = this.state
        if (tool === 'validation') {
            return
        }
        const offsetHours = this.getTempRefOffset()
        const getDates = () => measures.length > 1 ? `${i18n.fromDate} ${getFullDateInRef(startDate, offsetHours)} ${i18n.to} ${getFullDateInRef(endDate, offsetHours)}` : `${i18n.fromDate} ${getFullDateInRef(startDate, offsetHours)}`
        const eventProps = (() => {
            switch (tool) {
                case 'compensation':
                    const m1 = getMaintenance1(this.props.stationEvents, startDate, this.state)
                    const m2 = getMaintenance2(this.props.stationEvents, endDate, this.state)
                    const NGFoffset = this.state.displayCote === MEASURE_COTE.NGF ? changedValue : -changedValue
                    const NGFcoeff = compensationCoeff || 1
                    return {
                        comment: `${i18n.compensation} ${getDates()}\n
                    ${`Coeff : ${NGFcoeff}m NGF`}\n${`Offset : ${NGFoffset}m NGF`}${m1 ? `\n\n${m1}` : ''}${m2 ? `\n\n${m2}` : ''}`,
                        problem: JSON.stringify({
                            tool,
                            coeff: NGFcoeff,
                            offset: NGFoffset,
                        }),
                    }
                case 'purge':
                    const labelDelete = toolState.deleteMode === 'reset' ? i18n.reseting : (toolState.deleteMode === 'delete' ? i18n.deleteAction : i18n.purge)
                    return {
                        comment: `${labelDelete} ${getDates()}\n`,
                        problem: JSON.stringify({
                            tool,
                        }),
                    }
                // case 'validation':
                //     return {
                //         comment: `${i18n.validation} ${getDates()}\n
                //             ${toolState.status ? `${i18n.status} : ${getLabel(this.props.status, toolState.status)}\n` : ''}
                //             ${toolState.qualification ? `${i18n.qualification} : ${getLabel(this.props.qualifications, toolState.qualification)}` : ''}`,
                //         problem: JSON.stringify({
                //             tool,
                //         }),
                //     }
                case 'correction':
                    const mcorr1 = getMaintenance1(this.props.stationEvents, startDate, this.state)
                    const mcorr2 = getMaintenance2(this.props.stationEvents, endDate, this.state)
                    const NGFValue = this.state.displayCote === MEASURE_COTE.NGF ? changedValue : getNGFValue({ value: changedValue }, this.state.displayCote, this.state.lastLandmark, this.state.groundRefAlti)
                    const depthValue = this.state.displayCote === MEASURE_COTE.NGF ? getMeasureValue({ NGF: changedValue }, MEASURE_COTE.DEPTH, this.state.lastLandmark, this.state.groundRefAlti) : changedValue
                    return {
                        comment: `${i18n.driftingCorrection} ${getDates()}\n
                            ${i18n.valueLabel} : ${depthValue} m (${NGFValue} m NGF)${mcorr1 ? `\n\n${mcorr1}` : ''}${mcorr2 ? `\n\n${mcorr2}` : ''}`,
                        problem: JSON.stringify({ tool, NGFValue, depthValue }),
                    }
                case 'thresholds':
                    return {
                        comment: piezometerThresholds.filter(m => m.isNew).map(t => `${i18n.newThreshold} : ${t.value}\n`).join()
                            + piezometerThresholds.filter(m => m.isUpdated).map(t => `${i18n.updatedThreshold} : ${t.oldValue} => ${t.value}\n`).join()
                            + piezometerThresholds.filter(m => m.isDeleted).map(t => `${i18n.deletedThreshold} : ${t.value}\n`).join(),
                        problem: JSON.stringify({
                            tool,
                        }),
                    }
                case 'import':
                    return {
                        comment: this.getImportTechnicalEvent(measures),
                        problem: JSON.stringify({
                            tool,
                        }),
                    }
                default:
                    return { comment: '' }
            }
        })()

        const newEvent = {
            eventType: 'T',
            date: moment().valueOf(),
            eventHour: moment().valueOf(),
            startDate,
            endDate,
            graph: '1',
            ...eventProps,
        }

        this.props.addEvent('piezometry', this.props.params.id, newEvent)
            .then(() => this.setState({ open: false }))
    }

    getImportTechnicalEvent = (measures) => {
        const { startDateImport, endDateImport, display } = this.state
        const type = display === 'cumul' ? 'Cumul' : display === 'addEnd' ? 'Ajout Fin' : 'Remplacement'
        const description = `${i18n.manualImport}\n
            ${i18n.fromDate} ${getDateWithHourString(startDateImport)} ${i18n.to} ${getDateWithHourString(endDateImport)}\n
            ${i18n.type} : ${type}\n`
        switch (display) {
            case 'cumul':
            case 'addEnd':
                return `${description} ${i18n.numberImported} : ${measures.length}`
            case 'replace':
                return `${description} ${i18n.numberReplaced} : ${measures.insert}\n
                                    ${i18n.numberDeleted} : ${measures.delete}\n`
            default:
                return null
        }
    }

    getMaxDate = () => this.state.measures.length ? last(this.state.measures).date : null

    getToolContent = () => {
        const state = this.state
        const dates = pick(state, ['minDate', 'maxDate', 'startDate', 'endDate'])
        const datesImport = pick(state, ['startDateImport', 'endDateImport'])
        const params = {
            ...pick(state, [
                'selectionMode',
                'measures',
                'initialMeasures',
                'replayingCorrection',
                'draggable',
                'changedValue',
                'selectedPoint',
                'displayCote',
                'lastLandmark',
                'groundRefAlti',
                'display',
                'piezoMode',
                'selectedDataType',
                'tableView',
                'selectedCodePoint',
                'piezoMode',
            ]),
            dates,
            datesImport,
            changeParent: changes => this.setState(changes),
            createTechnicalEvent: this.createTechnicalEvent,
            updateTechnicalEvent: this.updateTechnicalEvent,
            onCancel: this.onCancel,
            id: this.props.params.id,
            piezometerThresholds: state.piezometerThresholds,
            piezometerImportedMeasure: state.piezometerImportedMeasure,
            getDataTypes: this.getDataTypes,
        }
        switch (state.tool) {
            case 'validation':
                return <ValidationToolPanel {...params} selectHisto={() => this.setState({ startDate: null, endDate: null })} />
            case 'purge':
                return <DeleteToolPanel {...params} />
            case 'compensation':
                return <CompensationToolPanel {...params} />
            case 'correction':
                return <CorrectionToolPanel {...params} />
            case 'event':
                return <EventsToolPanel {...params} />
            case 'thresholds':
                return <ThresholdsToolPanel {...params} />
            case 'import':
                return <ImportToolPanel {...params} />
            case 'options':
                return (
                    <OptionsToolPanel
                        {...params} chartOptions={this.state.chartOptions} isPiezo={state.piezoMode}
                        typeId={this.state.selectedDataType} yScale={this.yScale} withDateFormat={false}
                        landmarkValue={this.state.lastLandmark} stationType={STATION_TYPE_NAME.piezometry}
                    />
                )
            default:
                return (
                    <Card style={{ paddingTop: '8px', paddingBottom: '8px', paddingLeft: '8px' }}><h6>{i18n.inDeveloppmentFunctionnality}</h6></Card>
                )
        }
    }

    setDraggable = (rawMeasures) => {
        if (!this.state.dragging && this.state.draggable) {
            const chart = getComponentWithId('.sieauChart').getInstance()
            // chart.on('dataZoom', () => this.updatePosition(chart, rawMeasures))
            const start = this.state.startDate
            const end = this.state.endDate
            const filtered = (start && end && rawMeasures.filter(m => m.value[2] && m.value[0] >= start && m.value[0] <= end) || [])
            const lastMeasure = filtered && last(filtered)
            const toolObj = (() => {
                switch (this.state.tool) {
                    case 'validation':
                        return { measures: rawMeasures, onDrag: this.onPointDragging }
                    case 'compensation':
                        return { measures: filtered, onDrag: this.onPointDraggingCompensation, processedMeasures: filtered.map(m => m.value[2]) }
                    case 'correction':
                        return { measures: [lastMeasure], onDrag: this.onPointDraggingCorrection, processedMeasures: filtered.map(m => m.value[2]) }
                    default:
                        return null
                }
            })()
            if (toolObj) {
                chart.setOption({
                    graphic: toolObj.measures.map((item) => ({
                        type: 'circle',
                        position: chart.convertToPixel({ xAxisIndex: 1, yAxisIndex: 2 }, item.value),
                        shape: {
                            cx: 0,
                            cy: 0,
                            r: 5,
                        },
                        invisible: true,
                        draggable: true,
                        ondrag: (elem) => {
                            const newValue = chart.convertFromPixel({ xAxisIndex: 1, yAxisIndex: 2 }, [elem.offsetX, elem.offsetY])
                            toolObj.onDrag(newValue, item, toolObj.processedMeasures)
                        },
                        ondragstart: () => this.setState({ dragging: true }),
                        ondragend: () => this.setState({ dragging: false }),
                        onmousedown: () => {
                            if (this.state.selectionMode === 'point') {
                                this.setState({ selectedPoint: item.value[2] })
                            }
                        },
                        z: 100,
                        measure: item.value[2],
                    })),
                })
            }
        }
        return {}
    }

    onPointDragging = (newItem, item) => {
        const measure = item.value[2]
        if (!this.state.selectedPoint || this.state.selectedPoint.measureIndex === measure.measureIndex) {
            const diff = round(newItem[1] - measure.calculated)
            const funcNGF = this.state.displayCote === MEASURE_COTE.NGF ? (a, b) => round(a + b) : (a, b) => round(a - b)
            const funcDepth = this.state.displayCote === MEASURE_COTE.NGF ? (a, b) => round(a - b) : (a, b) => round(a + b)
            const newMeasure = { ...this.state.measures[measure.measureIndex], value: funcDepth(measure.value, diff), NGF: funcNGF(measure.NGF, diff), updated: true, calculated: newItem[1] }
            const newMeasures = Object.assign([], this.state.measures, {
                [measure.measureIndex]: newMeasure,
            })
            this.setState({ measures: newMeasures, selectedPoint: newMeasure, startDate: newMeasure.date, endDate: newMeasure.date })
            getComponentWithId('#validationToolPanel')?.setCancelButtonWhenMoving()
        }
    }

    onPointDraggingCompensation = (newItem, item, processedMeasures) => {
        const measure = item.value[2]

        // diff: différence avec la modif en cours
        const diff = round(newItem[1] - measure.calculated)

        // previousDiff: différence avec la mesure avant la modif en state (!= entre this.state.measures et this.state.initialMeasures)
        const previousCalculated = getMeasureValue(this.state.initialMeasures[measure.measureIndex], this.state.displayCote, this.state.lastLandmark, this.state.groundRefAlti)
        const previousDiff = round(newItem[1] - previousCalculated)

        // initialDiff: différence avec la mesure initiale (champs initialNGF et initialValue, stockés direct en base et qui ne changent jamais après l'import)
        const initialCalculated = getMeasureValue(measure, this.state.displayCote, this.state.lastLandmark, this.state.groundRefAlti, true)
        const initialDiff = round(newItem[1] - initialCalculated)

        const usedChangedValue = this.state.replayingCorrection ? initialDiff : previousDiff

        const funcNGF = this.state.displayCote === MEASURE_COTE.NGF ? (a, b) => round(a + b) : (a, b) => round(a - b)
        const funcDepth = this.state.displayCote === MEASURE_COTE.NGF ? (a, b) => round(a - b) : (a, b) => round(a + b)
        const changes = processedMeasures.reduce((acc, m) => ({ ...acc, [m.measureIndex]: { ...m, value: funcDepth(m.value, diff), NGF: funcNGF(m.NGF, diff), updated: true } }), {})
        const newMeasures = Object.assign([], this.state.measures, changes)
        this.setState({ measures: newMeasures, changedValue: usedChangedValue })
    }

    onPointDraggingCorrection = (newItem, item, processedMeasures) => {
        const measure = item.value[2]

        // diff: différence avec la modif en cours
        const diff = round(newItem[1] - measure.calculated)

        // previousDiff: différence avec la mesure avant la modif en state (!= entre this.state.measures et this.state.initialMeasures)
        // const previousCalculated = getMeasureValue(this.state.initialMeasures[measure.measureIndex], this.state.displayCote, this.state.lastLandmark, this.state.groundRefAlti)
        // const previousDiff = round(newItem[1] - previousCalculated)

        // initialDiff: différence avec la mesure initiale (champs initialNGF et initialValue, stockés direct en base et qui ne changent jamais après l'import)
        // const initialCalculated = getMeasureValue(measure, this.state.displayCote, this.state.lastLandmark, this.state.groundRefAlti, true)
        // const initialDiff = round(newItem[1] - initialCalculated)

        // const usedChangedValue = this.state.replayingCorrection ? initialDiff : previousDiff

        const len = processedMeasures.length
        const lastDate = processedMeasures[len - 1].date
        const timeDiff = lastDate - processedMeasures[0].date
        const getDiff = (m) => diff * (1 - ((lastDate - m.date) / timeDiff))
        const funcNGF = this.state.displayCote === MEASURE_COTE.NGF ? (a, b) => round(a + b) : (a, b) => round(a - b)
        const funcDepth = this.state.displayCote === MEASURE_COTE.NGF ? (a, b) => round(a - b) : (a, b) => round(a + b)
        const changes = processedMeasures.reduce((acc, m) => ({ ...acc, [m.measureIndex]: { ...m, value: funcDepth(m.value, getDiff(m)), NGF: funcNGF(m.NGF, getDiff(m)), updated: true } }), {})
        const newMeasures = Object.assign([], this.state.measures, changes)

        this.setState({ measures: newMeasures, changedValue: round(newItem[1]) })
    }

    getDataTypes = () => {
        return uniqBy(this.props.piezometerStatistics, 'typeId').map(t => this.props.piezometryDataTypes.find(t2 => t2.id === t.typeId))
    }

    getTable = () => {
        const { measures } = this.state
        const { piezometryDataTypes, piezometer } = this.props
        const roundValue = measures?.length ? piezometryDataTypes.find(pdt => pdt.id === measures[0].dataType)?.numberDecimal : DEFROUNDVALUE
        const qualifications = getQualifications()
        const offsetHours = this.getTempRefOffset()
        const data = this.state.measures.map(d => {
            const color = d.date === this.state.startDate || (d.date >= this.state.startDate && d.date <= this.state.endDate) ? '#7fdde9' : 'white'
            return {
                measure: d,
                date: { value: getFullDateInRef(d.date, offsetHours), sortValue: d.date, color },
                value: { value: this.state.piezoMode ? getMeasureValue(d, this.state.displayCote, this.state.lastLandmark, this.state.groundRefAlti, false, roundValue) : d.value, color },
                sensorValue: { value: d.initialValue + (d.cote === MEASURE_COTE.NGF ? ` [${getGeneralLevelling()}] ` : ''), color },
                initialValue: { value: this.state.piezoMode ? getMeasureValue(d, this.state.displayCote, this.state.lastLandmark, this.state.groundRefAlti, true, roundValue) : d.initialValue, color },
                status: { value: getLabel(getStatuses(), d.status), color: getMeasureStatusColorTable(d.status) },
                qualification: { value: getLabel(qualifications, d.qualification || UNQUALIFIED), color },
                nature: { value: getSandreIndexLabel(this.props.sandreIndex, SANDRE.PIEZOMETER_MEASURE_NATURE, d.nature), color },
                producer: { value: getObjectLabel(this.props.contributorsIndex[d.producer], 'mnemonique'), color },
                ptInitial: { value: d.initialPoint === IS_INITIAL_POINT ? i18n.yes : '', color },
            }
        })

        const getHeaderIcon = (title) => (<Grid container alignItems='center' columnSpacing={1}>{i18n[title]} <IconMui sx={{ color: PIEZOMETRY_COLOR.HELP }}>help</IconMui></Grid>)

        const headers = [
            'date',
            { key: 'value', value: getHeaderIcon('value'), tooltip: i18n.piezoValidation1 },
            { key: 'initialValue', value: getHeaderIcon('initialValue'), tooltip: i18n.piezoValidation3 },
            { key: 'sensorValue', value: getHeaderIcon('sensorValue'), tooltip: i18n.piezoValidation2 },
            'status', 'qualification', 'nature', 'producer', 'ptInitial',
        ]

        return (
            <Grid sx={{ padding: '20 10 0 0' }}>
                <CardTable
                    title={i18n.measures}
                    rows={data}
                    rowsPerPageOptions={nbPerPageLabel}
                    headers={headers}
                    onClickRow={m => this.selectPoint(m.measure)}
                    defaultSort={{ column: 'date', direction: 'desc' }}
                    actions={[{
                        icon: 'file_download',
                        onClick: () => {
                            exportFile({
                                data: this.getExportData(),
                                exportType: 'xlsx',
                                titleFile: `${i18n.overview} [${piezometer.code}] ${piezometer.name}`,
                            })
                        },
                        color: 'black',
                    }]}
                />
            </Grid>
        )
    }

    changeDataType = v => {
        const { tool, minDate, maxDate } = this.state
        const { piezometryDataTypes, piezometer } = this.props

        const newDt = piezometryDataTypes.find(dt => dt.id == v)
        const selectedCodePoint = piezometer.link_pointPrels.filter(p => p.typeId === v)[0]?.point
        const toolChange = ['validation', 'purge', 'options', 'thresholds', 'import'].includes(tool) ? {} : { tool: 'validation' }
        this.setState(
            { selectedDataType: v, dataLoaded: false, piezoMode: v === -1 || (newDt && newDt.isPiezo), startDate: null, endDate: null, selectedCodePoint, ...toolChange },
            () => this.loadData({ minDate, maxDate }),
        )
    }
    changeCodePoint = v => {
        const { tool, minDate, maxDate } = this.state
        const toolChange = ['validation', 'purge', 'options', 'thresholds', 'import'].includes(tool) ? {} : { tool: 'validation' }
        this.setState(
            { selectedCodePoint: v, dataLoaded: false, startDate: null, endDate: null, ...toolChange },
            () => this.loadData({ minDate, maxDate }),
        )
    }
    changeView = v => {
        const { measures, locked, piezometerImportedMeasure, tool } = this.state
        const changeDisabled = measures.filter(m => m.updated).length || locked || piezometerImportedMeasure.length
        if (!changeDisabled || ['validation', 'purge'].includes(tool)) {
            const toolChange = ['validation', 'purge'].includes(tool) ? {} : { tool: 'validation' }
            this.setState({ tableView: v, ...toolChange })
        }
    }
    getIcon = (icon) => {
        const { measures, locked, piezometerImportedMeasure, tool } = this.state
        const { piezometer } = this.props
        const changeDisabled = measures.filter(m => m.updated).length || locked || piezometerImportedMeasure.length
        return (
            <Tooltip title={icon.tooltip}>
                <img
                    className={`validationIcon clickable no-margin ${icon.tool === tool && 'activated'}`}
                    style={{ height: icon.height, width: icon.width }}
                    onClick={() => {
                        if (changeDisabled) {
                            this.props.warning(i18n.pleaseSaveModifs)
                        } else if (icon.tool === 'import' && (!piezometer?.link_altimetrySystems?.length || !piezometer?.link_landmarks.length)) {
                            this.props.warning('Les repères ou systèmes altimétriques ne sont pas renseignés')
                        } else {
                            this.setState({ tool: icon.tool })
                        }
                    }}
                    src={icon.icon}
                />
            </Tooltip>
        )
    }

    render() {
        const { measures, locked, piezometerImportedMeasure, selectedCodePoint, tableView, tool, piezoMode,
            selectedDataType, dataLoaded, time, displayModes, displayCote, filterStatusQualif,
        } = this.state
        const { piezometer, piezometryDataTypes } = this.props
        const { id } = piezometer
        const chartOption = this.state.chartOptions.find(d => parseInt(d.dataType ?? -1) === this.state.selectedDataType) || new DtoPiezometerChartOptions({
            dataType: this.state.selectedDataType.toString(),
            intervalYear: 5,
            displayXIntervalYear: '1',
            displayYIntervalYear: '1',
            displayData: true,
        })
        const mode = hasValue(chartOption.maxYear) || hasValue(chartOption.minYear) ? 'manual' : 'auto'

        if (id) {
            const changeDisabled = measures.filter(m => m.updated).length || locked || piezometerImportedMeasure.length
            const chronicDataTypes = [-1, ...piezometryDataTypes.filter(d => d.isPiezo).map(d => d.id)]
            const tools = [
                { icon: validateImg, tool: 'validation', height: 35, width: 35, tooltip: i18n.validation },
                { icon: purgeImg, tool: 'purge', height: 35, width: 30, tooltip: i18n.deleting },
                { icon: importImg, tool: 'import', height: 35, width: 30, tooltip: i18n.manualImport, hide: tableView },
                { icon: compensationImg, tool: 'compensation', height: 35, width: 50, tooltip: i18n.compensation, hide: tableView },
                { icon: correctionImg, tool: 'correction', height: 35, width: 45, tooltip: i18n.driftingCorrection, hide: tableView },
                { icon: optionsImg, tool: 'options', height: 35, width: 35, tooltip: i18n.chartOptions, hide: tableView },
                { icon: thresholdImg, tool: 'thresholds', height: 35, width: 35, tooltip: i18n.thresholds, hide: tableView },
                { icon: eventImg, tool: 'event', height: 35, width: 35, tooltip: i18n.events, hide: !piezoMode || tableView || !chronicDataTypes.includes(selectedDataType) },
            ].filter(t => !t.hide)

            return (
                <Grid container spacing={2} sx={{ pl: 2, pt: 1 }}>
                    <Grid size={9} sx={{ p: 1 }}>
                        <Card style={{ paddingTop: '8px', paddingLeft: '8px', paddingBottom: '8px' }}>
                            <Grid container size={12} alignItems='center'>
                                <MUIChartTabs
                                    offsetHours={this.getTempRefOffset()}
                                    time={time}
                                    onChangeTime={(changes) => this.loadData(changes)}
                                    timeKey={PIEZO_L_STORAGE.TIME_VALIDATION}
                                    otherTimeKey={PIEZO_L_STORAGE.TIME_OTHER_VALIDATION}
                                />
                                <Grid sx={{ paddingLeft: '20px' }}>
                                    <ChartOptionsChip
                                        displayModes={displayModes}
                                        displayCote={displayCote}
                                        filterStatusQualif={filterStatusQualif}
                                        changeParent={changes => this.setState({ ...changes, dataLoaded: false }, () => this.loadData(pick(this.state, ['minDate', 'maxDate'])))}
                                        withReferenceLevel={piezoMode}
                                        withInitialDisplay={true}
                                        withSupprDisplay={true}
                                        noSol={!this.props.piezometer.link_landmarks.some(l => l.origin === 3)} // pas de mode SOL
                                        displayModesKey={PIEZO_L_STORAGE.DISPLAY_MODES_DASHBOARD}
                                        filterStatusQualifKey={PIEZO_L_STORAGE.STATUS_QUALIF_DASHBOARD}
                                        noAuto
                                    />
                                </Grid>
                                <Grid sx={{ paddingLeft: '10px' }}>
                                    <ChartTempRefChip
                                        tempRef={this.state.tempRef}
                                        offsetHours={this.getTempRefOffset()}
                                        stationOffsetHours={this.getStationTempRefOffset()}
                                        stationTempRefs={this.props.piezometer?.link_tempRefs}
                                        onChange={this.changeTempRef}
                                    />
                                </Grid>
                                <Grid
                                    onClick={() => {
                                        if (changeDisabled) {
                                            this.props.warning(i18n.pleaseSaveModifs)
                                        } else {
                                            this.setState({ tool: 'options' })
                                        }
                                    }}
                                    sx={{
                                        cursor: 'pointer',
                                        backgroundColor: 'rgba(53, 96, 159, 1)',
                                        color: 'white',
                                        padding: '0px 9px',
                                        borderTop: '2px solid rgba(53, 96, 159, 1)',
                                        borderLeft: '2px solid rgba(53, 96, 159, 1)',
                                        borderRight: '2px solid rgba(53, 96, 159, 1)',
                                        borderRadius: '5px',
                                        marginLeft: 'auto',
                                        marginRight: '20px',
                                        height: '2.7rem',
                                    }}
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'center'}
                                >
                                    {i18n.chartScale} : {mode === 'auto' ? i18n.automatic : i18n.manual}
                                </Grid>
                            </Grid>
                            {dataLoaded ? (tableView ? this.getTable() : this.getChart()) : <MessageCard sx={{ pt: 7, pl: 2, pr: 2, pb: 2 }}>{i18n.loading}</MessageCard>}
                        </Card>
                    </Grid>
                    <Grid size={3}>
                        <Card style={{ padding: '16px' }}>
                            <Grid container spacing={1} alignItems='center' sx={{ pt: 1 }}>
                                <Grid size={9} offset={0.25}>
                                    <Select
                                        fullwidth
                                        value={selectedDataType}
                                        options={orderBy(this.getDataTypes(), 'order', 'asc')}
                                        noSort
                                        label={i18n.dataType}
                                        onChange={this.changeDataType}
                                        disabled={changeDisabled}
                                        noNullValue
                                    />
                                </Grid>
                                <Grid size={2}>
                                    <Icon
                                        icon={tableView ? 'multiline_chart' : 'list'}
                                        onClick={() => this.changeView(!tableView)}
                                        style={{ fontSize: '2.5rem', color: changeDisabled && !['validation', 'purge'].includes(tool) ? GREY : PIEZOMETRY_COLOR.DEPTH }}
                                        tooltip={tableView ? i18n.graphicMode : i18n.tableMode}
                                    />
                                </Grid>
                            </Grid>
                            <Grid size={9} sx={{ pt: 1 }} offset={0.25}>
                                <Select size={9}
                                    value={selectedCodePoint}
                                    options={piezometer.link_pointPrels.filter(p => p.typeId === selectedDataType)}
                                    keyValue='point' noSort label={i18n.pointPrelevement}
                                    onChange={this.changeCodePoint}
                                    disabled={changeDisabled}
                                    noNullValue
                                />
                            </Grid>
                        </Card>
                        <Grid sx={{ pt: 1 }} />
                        <Card>
                            <Grid container spacing={0} sx={{ justifyContent: 'center', paddingTop: 1, paddingBottom: 1 }}>
                                {tools.map(icon => (
                                    <Grid key={icon.tool} >
                                        {this.getIcon(icon)}
                                    </Grid>
                                ))}
                            </Grid>
                        </Card>
                        <Grid sx={{ pt: 2 }} />
                        {this.getToolContent()}
                    </Grid>
                </Grid>
            )
        }
        return null
    }
}

PiezometryValidationApp.propTypes = {
    params: PropTypes.shape({
        id: PropTypes.string,
    }),
    piezometer: PropTypes.instanceOf(DtoPiezometer),
    measures: PropTypes.arrayOf(DtoPiezometryStationMeasure),
    piezometerImportedMeasure: PropTypes.arrayOf(DtoPiezometryStationMeasure),
    stationEvents: PropTypes.arrayOf(DtoEvent),
    piezometerChartOptions: PropTypes.arrayOf(DtoPiezometerChartOptions),
    piezometerThresholds: PropTypes.arrayOf(DtoPiezoThreshold),
    status: PropTypes.arrayOf(DtoStatus),
    qualifications: PropTypes.arrayOf(DtoQualification),
    sandreCodes: PropTypes.arrayOf(DtoSandreCode),
    contributors: PropTypes.arrayOf(DtoContributor),
    contributorsIndex: PropTypes.objectOf(DtoContributor),
    sandreIndex: PropTypes.objectOf(objectOf(DtoSandreCode)),
    jobs: PropTypes.arrayOf(DtoJob),
    piezometers: PropTypes.arrayOf(DtoPiezometerLight),
    location: PropTypes.shape({
        pathname: PropTypes.string,
        search: PropTypes.object,
    }),
    piezometryDataTypes: PropTypes.arrayOf(DtoParametrageDataType),
    fetchMeasures: PropTypes.func,
    push: PropTypes.func,
    addEvent: PropTypes.func,
    updateEvent: PropTypes.func,
    fetchPiezometryDataTypes: PropTypes.func,
    fetchPiezometerThresholds: PropTypes.func,
    fetchContributors: PropTypes.func,
    setTitle: PropTypes.func,
    error: PropTypes.func,
    warning: PropTypes.func,
    fetchPiezometerChartOptions: PropTypes.func,
    fetchStatus: PropTypes.func,
    fetchQualifications: PropTypes.func,
    fetchSandreCodes: PropTypes.func,
    fetchFullJobs: PropTypes.func,
    fetchPiezoMeasuresStats: PropTypes.func,
    typeEnvironmentModels: PropTypes.arrayOf(PropTypes.string),
    piezometerStatistics: PropTypes.arrayOf(DtoMeasureStats),
    hidefilterStatusQualif: PropTypes.bool,
    citiesIndex: PropTypes.objectOf(PropTypes.shape({
        name: PropTypes.string,
    })),
}

const mapStateToProps = store => ({
    piezometer: store.StationReducer.piezometer,
    piezometers: store.PiezometryReducer.piezometersLight,
    measures: store.PiezometerStationReducer.piezoValidationChartMeasures,
    stationEvents: store.EventsReducer.stationEvents,
    piezometerChartOptions: store.PiezometerStationReducer.piezometerChartOptions,
    piezometerThresholds: store.PiezometerStationReducer.piezometerThresholds,
    status: store.QualityReducer.status,
    qualifications: store.QualityReducer.qualifications,
    sandreCodes: store.ReferencialReducer.sandreCodes,
    sandreIndex: store.ReferencialReducer.sandreIndex,
    contributors: store.ContributorReducer.contributors,
    contributorsIndex: store.ContributorReducer.contributorsIndex,
    jobs: store.JobReducer.jobs,
    applicationSettings: store.AdministrationReducer.applicationSettings,
    piezometryDataTypes: store.PiezometryReducer.piezometryDataTypes,
    typeEnvironmentModels: store.ExportReducer.typeEnvironmentModels,
    piezometerStatistics: store.PiezometerStationReducer.piezometerStatistics,
    citiesIndex: store.CityReducer.citiesIndex,
})

const mapDispatchToProps = {
    addEvent: EventsAction.addEvent,
    updateEvent: EventsAction.updateEvent,
    warning: ToastrAction.warning,
    fetchMeasures: PiezometerStationAction.fetchPiezoValidationMeasures,
    fetchPiezometryDataTypes: PiezometryAction.fetchPiezometryDataTypes,
    fetchPiezometerThresholds: PiezometerStationAction.fetchPiezometerThresholds,
    fetchPiezoMeasuresStats: PiezometerStationAction.fetchPiezoMeasuresStats,
    fetchContributors: ContributorAction.fetchContributors,
    fetchPiezometerChartOptions: PiezometerStationAction.fetchPiezometerChartOptions,
    fetchStatus: QualityAction.fetchStatus,
    fetchQualifications: QualityAction.fetchQualifications,
    fetchSandreCodes: ReferencialAction.fetchSandreCodes,
    fetchFullJobs: JobAction.fetchFullJobs,
    setTitle: HomeAction.setTitle,
    error: ToastrAction.error,
    push,
}

export default connect(mapStateToProps, mapDispatchToProps)(PiezometryValidationApp)
